import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { AlertTriangle, Download, Printer } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { STORE } from "@/lib/store";

const siteUrl = () => `${window.location.origin}/`;
const isPreview = () => /preview\.emergentagent\.com|localhost/.test(window.location.host);

const posterHtml = (qr, url) => `<!doctype html><html><head><title>RamVilas QR</title>
<style>body{margin:0;font-family:Georgia,serif;background:#FDFBF7;color:#1B4332;text-align:center}
.p{padding:48px 32px}h1{font-size:40px;margin:8px 0}h2{font-family:Arial,sans-serif;font-weight:600;color:#8B5A2B;letter-spacing:3px;font-size:14px;text-transform:uppercase}
img{width:420px;height:420px;margin:24px auto;display:block;border:10px solid #fff;box-shadow:0 0 0 3px #C59B27}
p{font-family:Arial,sans-serif;font-size:18px;margin:6px 0}.u{font-size:14px;color:#5B625D}</style></head>
<body><div class="p"><h2>Namaste · नमस्ते</h2><h1>${STORE.name}</h1>
<p>Scan to see our products &amp; WhatsApp us</p><img src="${qr}" alt="QR code"/>
<p>WhatsApp: ${STORE.whatsappDisplay}</p><p class="u">${url}</p><p class="u">${STORE.addressShort}</p></div>
<script>window.onload=()=>setTimeout(()=>window.print(),300)</script></body></html>`;

export const ShopQR = () => {
  const ref = useRef(null);
  const { logo } = useSiteSettings();
  const url = siteUrl();
  const dataUrl = () => ref.current?.toDataURL("image/png");

  const download = () => {
    const a = document.createElement("a");
    a.href = dataUrl();
    a.download = "ramvilas-website-qr.png";
    a.click();
  };
  const print = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(posterHtml(dataUrl(), url));
    w.document.close();
  };

  return (
    <div className="grid gap-6 rounded-2xl border border-[#E5E0D8] bg-white p-5 md:grid-cols-[auto_1fr]" data-testid="shop-qr-panel">
      <div className="mx-auto rounded-2xl border-4 border-[#C59B27]/50 bg-white p-3">
        <QRCodeCanvas ref={ref} value={url} size={1024} level="H" marginSize={2} fgColor="#10291F"
                      imageSettings={logo ? { src: logo, height: 220, width: 220, excavate: true, crossOrigin: "anonymous" } : undefined}
                      style={{ width: 240, height: 240 }} data-testid="shop-qr-code" />
      </div>
      <div>
        <p className="font-display text-2xl font-bold text-[#1B4332]">Website QR code</p>
        <p className="mt-1 text-sm text-[#5B625D]">Customers scan this to open your website. It points to:</p>
        <p className="mt-2 break-all rounded-lg bg-[#F4EEE2] px-3 py-2 font-mono text-sm" data-testid="shop-qr-url">{url}</p>
        {isPreview() && (
          <p className="mt-3 flex gap-2 rounded-xl bg-[#FBF1D6] p-3 text-sm text-[#7A5A0B]" data-testid="shop-qr-preview-warning">
            <AlertTriangle className="h-5 w-5 shrink-0" /> This is a temporary preview address. Publish the website and open this page on your permanent domain before printing the banner QR.
          </p>
        )}
        <div className="mt-4 flex flex-col gap-2 sm:flex-row">
          <button onClick={download} className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-[#1B4332] px-5 font-semibold text-white" data-testid="shop-qr-download-btn"><Download className="h-4 w-4" /> Download PNG</button>
          <button onClick={print} className="inline-flex h-11 items-center justify-center gap-2 rounded-full border border-[#1B4332]/30 px-5 font-semibold text-[#1B4332]" data-testid="shop-qr-print-btn"><Printer className="h-4 w-4" /> Print poster</button>
        </div>
      </div>
    </div>
  );
};
